module.exports = __webpack_public_path__ + "1029d90b9e3738419137215606676b77.svg";